import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, FormGroup } from "react-bootstrap";
import locale from "locale";
import * as Api from '../../../../api/cp/pdfSchedule';
import Breadcrumbs from "../../UI/Breadcrumbs";
import SettingsSidebar from "./SettingsSidebar";

const SchedulePdfConstructorPage  = ({event}) => {
    const [settings, setSettings] = useState(null);
    const [isSaving, setSaving] = useState(false);
    const breadcrumbs = [
        'mainMenu.schedule',
        'mainMenu.pdfConstructor',
    ];

    console.log(settings)

    useEffect(() => {
        handleGetConstructorSettings();
    }, [event]);

    function handleChangeSettings(value) {
        setSettings({
            ...settings,
            ...value,
        });
    };

    async function handleCreateConstructorSettings() {
        try {
            const response = await Api.createPdfScheduleSettings(event.eventKey);
            setSettings(response);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleGetConstructorSettings() {
        try {
            let response = await Api.getPdfScheduleSettings(event.eventKey);
            if (response.id) {
                setSettings(response);
            } else {
                handleCreateConstructorSettings();
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function handleUpdateConstructorSettings() {
        try {
            setSaving(true);
            const response = await Api.updatePdfScheduleSettings(settings.id, settings);
            setSettings(response);
            setSaving(false);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <section>
            <Breadcrumbs
                link={`/event/${event.eventPassword}`}
                activeCrumbs={breadcrumbs}
            />

            <div
                style={{
                    marginBottom: '60px',
                    display: 'flex',
                    columnGap: '40px',
                }}
            >
                <div style={{width: '36%'}}>
                    <FormGroup>
                        <Button
                            bsStyle="primary"
                            disabled={isSaving}
                            onClick={handleUpdateConstructorSettings}
                        >
                            {locale('settings.saveSettings')}
                        </Button>
                    </FormGroup>
                    <SettingsSidebar
                        settings={settings}
                        onChange={handleChangeSettings}
                    />
                </div>
                <div style={{width: '64%'}}>
                    {/* Constructor PDF */}
                </div>
            </div> 
        </section>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent,
    };
};

export default connect(mapStateToProps)(SchedulePdfConstructorPage);
